import start from './start';
import appeals from './appeals';
import bdd from './bdd';
import fileBDD from './file-bdd';
import unableToFileBDD from './unable-to-file-bdd';
import fileClaim from './file-claim';
import fileClaimEarly from './file-claim-early';
import disagreeFileClaim from './disagree-file-claim';

export default [
  start,
  appeals,
  bdd,
  fileBDD,
  unableToFileBDD,
  fileClaim,
  fileClaimEarly,
  disagreeFileClaim,
];
